import PropTypes from 'prop-types';
import React from 'react';

export default class DeliverableIcon extends React.Component {
    render() {
        return (
            <div className="deliverable-icon">
                <span className="deliverable-icon__inner">{this.props.extension}</span>
            </div>
        );
    }
}

DeliverableIcon.propTypes = {
    extension: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/deliverable-icon.jsx